import { Condition, ConditionGroup } from 'editor/src/store/design/types';
import { RootState } from 'editor/src/store/index';

export interface ConditionLocation {
  condition: Condition;
  conditionGroup: ConditionGroup;
  spreadIndex: number;
}

/**
 * Locates a condition by id anywhere in the design, together with the spread
 * that stores it.
 *
 * Condition ids are unique across the whole design, so finding one is a lookup
 * rather than a disambiguation — but the OWNING spread is what callers actually
 * need. A design-scoped picklist is operated from pages that do not store it,
 * and both the reflow recompute and the active-option dispatch have to name the
 * spread that owns the condition, not the one being viewed.
 */
const getConditionById = (state: RootState, conditionId: string): ConditionLocation | undefined => {
  const spreads = state.design.designData?.spreads;
  if (!spreads) {
    return undefined;
  }

  for (let spreadIndex = 0; spreadIndex < spreads.length; spreadIndex += 1) {
    const { conditionGroup } = spreads[spreadIndex];
    const condition = conditionGroup?.conditions[conditionId];
    if (conditionGroup && condition) {
      return { condition, conditionGroup, spreadIndex };
    }
  }

  return undefined;
};

export default getConditionById;
